module.exports = __webpack_public_path__ + "img/icon_z3.e1c620f.png";